import React, { useState, useRef, useEffect } from "react";
import { Menu, MenuItem, ProSidebar, SubMenu } from 'react-pro-sidebar';

import { Link  } from "react-router-dom";
import "react-pro-sidebar/dist/css/styles.css";
import { Box, Typography } from "@mui/material";


const Item = ({ title, to, icon, selected, setSelected }) => {


  return (
    <MenuItem
      active={selected === title}
      onClick={() => setSelected(title)}
    >
      <Typography>{title}</Typography>
      <Link to={to} />
    </MenuItem>
  );
};

const Sidebar = () => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [selected, setSelected] = useState("Dashboard");
  const [selectedMenuItem, setSelectedMenuItem] = useState('');
  const [openSubMenu, setOpenSubMenu] = useState('');
  const sidebarRef = useRef(null);
  

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setIsCollapsed(true);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleMouseEnter = () => {
    setIsCollapsed(false);
  };

  const handleMouseLeave = () => {
    setIsCollapsed(false);
  };

  const handleMouseMove = () => {
    setIsCollapsed(false);
  };

  const handleSidebarClick = (event) => {
    event.stopPropagation();
  };

  const handleOutsideClick = (event) => {
    if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
      setIsCollapsed(true); // Close the sidebar drawer
    }
  };
  
  // Add event listener to handle outside clicks
  useEffect(() => {
    document.addEventListener('click', handleOutsideClick);
  
    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);

  return (
    <>
    
    <Box onMouseMove={handleMouseMove}>
      <div id="sidebarTrigger" onClick={() => setIsCollapsed(!isCollapsed)}></div>
      <ProSidebar
  collapsed={isCollapsed}
  onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave}
  ref={sidebarRef}
  styles={{
    transition: 'transform 0.10s ease', // Adjust the transition duration here (0.5s)
    transform: isCollapsed ? 'translateX(-260px)' : 'translateX(0)'
  }}
>
        <Menu iconShape="square">              

          <Box>
          <Typography
              variant="h6"
          
              sx={{ m: "15px 0 5px 20px" }}
            >
              Mains
            </Typography>

            <MenuItem className={selectedMenuItem === 'TaskManager' ? 'active' : ''} onClick={() => { setSelectedMenuItem('TaskManager'); setOpenSubMenu('TaskManager'); }}><i className="icon-union"></i> Task Manager</MenuItem>

            <MenuItem className={selectedMenuItem === 'Dashboard' ? 'active' : ''} onClick={() => { setSelectedMenuItem('Dashboard'); setOpenSubMenu('Dashboard'); }}><i className="icon-home"></i> Dashboard</MenuItem>
            
            <SubMenu title={<><i className="custom-icon icon-graph"></i> Stocks</>} open={openSubMenu === 'Stocks'} onOpen={() => setOpenSubMenu('Stocks')} onClick={() => setOpenSubMenu('Stocks')}>

              <MenuItem className={selectedMenuItem === 'Compliance' ? 'active' : ''} onClick={() => { setSelectedMenuItem('Compliance'); setOpenSubMenu('Stocks'); }}><Link to="/">Compliance Reports</Link></MenuItem>
              <MenuItem  className={selectedMenuItem === 'Company' ? 'active' : ''} onClick={() => { setSelectedMenuItem('Company'); setOpenSubMenu('Stocks'); }}>  <Link to="/company-profile">Company Profile</Link></MenuItem>
              <MenuItem  className={selectedMenuItem === 'Report' ? 'active' : ''} onClick={() => { setSelectedMenuItem('Report'); setOpenSubMenu('Stocks'); }}>  <Link to="/report">Reports</Link></MenuItem>                        
            
            </SubMenu>

            <SubMenu title={<><i className="custom-icon icon-graph"></i> ETFS</>} open={openSubMenu === 'ETFS'} onOpen={() => setOpenSubMenu('ETFS')} onClick={() => setOpenSubMenu('ETFS')}>
              <MenuItem className={selectedMenuItem === 'ETFs' ? 'active' : ''} onClick={() => { setSelectedMenuItem('ETFs'); setOpenSubMenu('ETFS'); }}>ETFs</MenuItem>
              <MenuItem className={selectedMenuItem === 'HoldingBasket' ? 'active' : ''} onClick={() => { setSelectedMenuItem('HoldingBasket'); setOpenSubMenu('ETFS'); }}>ETF Holding Basket</MenuItem>                                     
            </SubMenu> 
                     
            <MenuItem className={selectedMenuItem === 'MarketIndexes' ? 'active' : ''} onClick={() => { setSelectedMenuItem('MarketIndexes'); setOpenSubMenu('MarketIndexes'); }}><i className="fa fa-file-text-o"></i> Market Indexes</MenuItem> 
            <MenuItem className={selectedMenuItem === 'StockRequests' ? 'active' : ''} onClick={() => { setSelectedMenuItem('StockRequests'); setOpenSubMenu('StockRequests'); }}><i className="fa fa-file-text-o"></i> Stock Requests</MenuItem> 
            <MenuItem className={selectedMenuItem === 'ChartReports' ? 'active' : ''} onClick={() => setSelectedMenuItem('ChartReports')}><i className="fa-solid fa-chart-simple"></i><Link to="/chart-reports"> Chart Reports</Link></MenuItem>
            <MenuItem className={selectedMenuItem === 'ChartReports' ? 'active' : ''} onClick={() => setSelectedMenuItem('ChartReports')}><i className="fa-solid fa-chart-simple"></i><Link to="/full-charts"> Full Charts</Link></MenuItem>

            
            <Typography
              variant="h6"
              sx={{ m: "15px 0 5px 20px" }}
              className="menu_setting_section"
            >
              Settings
            </Typography>
            <SubMenu title={<><i className="custom-icon icon-user"></i> Account</>} open={openSubMenu === 'Account'} onOpen={() => setOpenSubMenu('Account')} onClick={() => setOpenSubMenu('Account')}>
              <MenuItem className={selectedMenuItem === 'Account-2' ? 'active' : ''} onClick={() => { setSelectedMenuItem('Account-2'); setOpenSubMenu('Account'); }}>Account-2</MenuItem>                                   
            </SubMenu> 

            <SubMenu title={<><i className="custom-icon icon-setting"></i> Settings</>} open={openSubMenu === 'Settings'} onOpen={() => setOpenSubMenu('Settings')} onClick={() => setOpenSubMenu('Settings')}>
              <MenuItem className={selectedMenuItem === 'Settings-2' ? 'active' : ''} onClick={() => { setSelectedMenuItem('Settings-2'); setOpenSubMenu('Settings'); }}>Settings-2</MenuItem>                                   
            </SubMenu> 
            
          </Box>
        </Menu>
      </ProSidebar>
    </Box>
    </>
  );
};

export default Sidebar;
